<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-color-rule-table name="light" shuxing="font" v-ot-loading="loading" :ot-loading-text="label" ot-loading-spinner="spinner">
            </ot-color-rule-table>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            label: '2O3T Loading',
            loading: true,
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-color-rule-table%20name%3D%22light%22%20shuxing%3D%22font%22%20v-ot-loading%3D%22loading%22%20%3Aot-loading-text%3D%22label%22%20ot-loading-spinner%3D%22spinner%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-color-rule-table%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20label%3A%20'2O3T%20Loading'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20loading%3A%20true%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
